import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  tab: {
    backgroundColor: theme.palette.primary.dark,
  },
  content: {
    maxWidth: theme.breakpoints.values['content'],
    margin: 'auto',
    textAlign: 'left',
  },
  noPad: {
    padding: '0 !important',
  },
  hideMobile: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  onlyMobile: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
}));

export default useStyles;
